import Scale from "./scale";

export default class ScaleDesktop extends Scale {
  preScale() {
    super.preScale();
    $(".arena-workspace").css({
      height: `${Math.max(this.$$.sectionOuterHeight * this.$$.baseScale, 350)}px`,
    });
    return this;
  }
}

window.SectionScaleDesktop = ScaleDesktop;
